/**
 * 仅处理「展会语义列表」分页确认跳转（Island SSR 静态 HTML）。
 * 必须带 data-fair-pager-jump + data-semantic-page-prefix；资讯/会展中心等勿挂这些属性（走 link+页码）。
 * 见 Pagination `.btn-jump[data-fair-pager-jump]`。
 */
import { fairSemanticListPathWithTrailingSlash } from '~/utils/fairSemanticListing'

function buildFairListPagerHref(prefixRaw: string, page: number, querySuffix: string): string {
  const pg = Math.max(1, Math.floor(page) || 1)
  // 仅允许语义前缀拼 /p-{n}/，禁止回退到任意 pathname（否则其它模块会 404）
  const base = (prefixRaw || '').trim().replace(/\/p-\d+\/?$/i, '').replace(/\/+$/, '')
  if (!base) return ''
  const path = pg <= 1 ? base : `${base}/p-${pg}`
  const q =
    querySuffix ||
    (typeof location !== 'undefined' && location.search ? location.search : '')
  return fairSemanticListPathWithTrailingSlash(`${path}${q}`)
}

function handleFairListPagerJump(e: Event) {
  const target = e.target
  if (!(target instanceof Element)) return
  const btn = target.closest('a.btn-jump[data-fair-pager-jump]')
  if (!(btn instanceof HTMLAnchorElement)) return

  // 隔离：无语义前缀则不拦截，避免 /information-…/p-2/ 这类错误 URL
  const prefix = btn.getAttribute('data-semantic-page-prefix') || ''
  if (!prefix.trim()) return

  e.preventDefault()

  const jumpBox = btn.previousElementSibling
  const input = jumpBox?.querySelector('.jump-input')
  const maxPage = Math.max(1, parseInt(btn.getAttribute('data-max-page') || '1', 10) || 1)
  let page = parseInt(String((input as HTMLInputElement | null)?.value ?? ''), 10) || 1
  page = Math.max(1, Math.min(maxPage, page))

  const querySuffix = btn.getAttribute('data-query-suffix') || ''
  const href = buildFairListPagerHref(prefix, page, querySuffix)
  if (!href) return
  window.location.href = href
}

function handleFairListPagerEnter(e: Event) {
  if (!(e instanceof KeyboardEvent) || e.key !== 'Enter') return
  const target = e.target
  if (!(target instanceof HTMLInputElement) || !target.classList.contains('jump-input')) return
  const jumpBox = target.closest('.pager-jump')
  const btn = jumpBox?.nextElementSibling
  if (!(btn instanceof HTMLAnchorElement) || !btn.matches('.btn-jump[data-fair-pager-jump]')) return
  // 同上：仅展会语义确认按钮
  if (!(btn.getAttribute('data-semantic-page-prefix') || '').trim()) return
  e.preventDefault()
  btn.click()
}

export default defineNuxtPlugin(() => {
  document.addEventListener('click', handleFairListPagerJump, true)
  document.addEventListener('keydown', handleFairListPagerEnter, true)
})
